import * as React from 'react';
import PropTypes from 'prop-types';

import { Typography, withStyles } from '@material-ui/core';
import { hasValueForQuestionType } from './FormQuestion';
import { getElementConditionState } from '../../elementStateUtils';
import { elementConditionStates } from '../../constants';

const styles = theme => ({
    validationText: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
        width: '100%',
        outline: 'none',
    },
});

class FormValidation extends React.Component {
    state = {
        missingRequiredQuestions: false,
    }

    validationErrorRef = React.createRef()

    componentDidUpdate(prevProps, prevState) {
        // Focus on validation error when appearing
        if (!prevState.missingRequiredQuestions && this.state.missingRequiredQuestions) {
            if (this.validationErrorRef.current) this.validationErrorRef.current.focus();
        }
    }

    validate = () => {
        const {
            task, responses, getProgramItem, getSpecificTaskResponses,
        } = this.props;

        if (!task.contentElements?.length) {
            return true;
        }
        const missingRequiredQuestions = task.contentElements.map((e) => {
            const contentState = getElementConditionState(e, getSpecificTaskResponses, task, getProgramItem);
            if (contentState === elementConditionStates.hidden) {
                return false;
            }
            return e.questions?.reduce((prev, curr) => prev
                || (curr.required && (!responses || !hasValueForQuestionType(curr.type, responses[curr.id]?.response))),
                false
            );
        }).some(d => d);

        this.setState({ missingRequiredQuestions });
        return !missingRequiredQuestions;
    }

    render() {
        const {
            classes, task, translations, showValidations,
        } = this.props;

        if (!task) {
            return null;
        }

        if (!this.state.missingRequiredQuestions || !showValidations) {
            return null;
        }

        return (
            <Typography color="error" tabIndex={-1} ref={this.validationErrorRef} className={classes.validationText}>
                {translations?.answerAllRequiredQuestions || '*'}
            </Typography>
        );
    }
}

FormValidation.propTypes = {
    classes: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    translations: PropTypes.object,
    showValidations: PropTypes.bool,
    responses: PropTypes.object,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
};

FormValidation.defaultProps = {
    translations: null,
    showValidations: false,
    responses: null,
};

export default withStyles(styles)(FormValidation);
